<template>
  <tr>
    <td v-if="isFolderSelectMode" class="px-3 doc-check">
      <v-checkbox v-model="isFolderSelected" @change="selectFolder()"
        :disabled="folderSelection !== '' && folderSelection !== listItem.path" primary hide-details
        color="secondary"></v-checkbox>
    </td>
    <td v-if="isAttachmentMode" class="px-3 doc-check"></td>
    <td class="doc-primary-td text-truncate">
      <v-flex>
        <font-awesome-icon :style="{ color: 'orange' }" size="2x" :icon="['fas', listItem.icon]"
          class="mr-3"></font-awesome-icon>
        <h3 class="d-inline-block"><a href="#" @click.prevent="navigateToFolder(listItem)">{{ listItem.name }}</a></h3>
      </v-flex>
      <v-menu v-if="!listItem.templateDefined || (listItem.templateDefined && isConfigMode)" nudge-top="40px" right
        offset-y transition="scale-transition">
        <v-btn flat slot="activator" icon class="ma-0 pa-0" dark color="secondary">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile @click="renameDialog = true">
            <v-icon class="mr-2" color="secondary">drive_file_rename_outline</v-icon>Rename
          </v-list-tile>
          <v-list-tile @click="deleteDialog = true">
            <v-icon class="mr-2" color="error">delete</v-icon>Delete</v-list-tile>
        </v-list>
      </v-menu>
    </td>
    <td v-if="displayColumn('date')" class="text-truncate">
      <span v-if="listItem.templateDefined">-</span>
      <span v-else>{{ listItem.date }}</span>
    </td>
    <td v-if="displayColumn('size')" class="text-truncate">-</td>
    <td v-if="displayColumn('modified')" class="text-truncate">
      <span v-if="isConfigMode">{{ listItem.modified }}</span>
      <span v-else>-</span>
    </td>

    <v-dialog v-model="renameDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Rename folder</h2>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-text-field box label="Folder name" v-model="folderName"></v-text-field>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="updateFolder(folderName, listItem.id, listItem.parentFolderId)" color="success">Update
            name</v-btn>
          <v-btn @click="renameDialog = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-0">
          <h2>Delete folder</h2>
        </v-card-title>
        <v-card-text class="px-0 pb-3">
          Are you sure you want to delete this folder? This cannot be undone.
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="deleteFolder(listItem.id)" color="error">Confirm deletion</v-btn>
          <v-btn @click="deleteDialog = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </tr>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "folder-list-item",
  props: [
    'listItem',
    'documentHeaders',
    'isConfigMode',
    'isAttachmentMode',
    'isFolderSelectMode'
  ],
  data: () => ({
    newFolderDialog: false,
    renameDialog: false,
    duplicateDialog: false,
    moveDialog: false,
    copyDialog: false,
    deleteDialog: false,
    folderName: '',
    isFolderSelected: false
  }),
  computed: {
    ...mapState({
      folderSelection: (state) => {
        if (state.folders.currentFolderSelection && state.folders.currentFolderSelection.path) {
          return state.folders.currentFolderSelection.path
        }
        return ''
      }
    })
  },
  methods: {
    displayColumn(column) {
      if (!this.documentHeaders) return false
      return this.documentHeaders.find(header => header.value === column)
    },
    navigateToFolder(folder) {
      this.$emit("folder-navigate", folder)
    },
    deleteFolder(folderId) {
      this.$emit("folder-delete", folderId)
      this.deleteDialog = false
    },
    updateFolder(folderName, folderId, parentFolderId) {
      this.$emit("folder-update", { folderName, folderId, parentFolderId })
      this.renameDialog = false
    },
    selectFolder() {
      this.$store.dispatch('setCurrentFolderSelection', { folder: this.listItem, selected: this.isFolderSelected })
    }
  },
  watch: {
    folderSelection: {
      handler: function (newVal, oldVal) {
        if (this.listItem.path === this.folderSelection) {
          this.isFolderSelected = true
        }
      },
      deep: false,
      immediate: true
    }
  }
}
</script>
